export default {
  methods: {
    showSnackbar({ msg, color, prependIcon }) {
      if (!msg) {
        return
      }
      this.$notifier.showMessage({
        content: msg,
        color: color || 'info',
        prependIcon
      })
    }
  }
}
